@file:OptIn(InternalResourceApi::class)

package advancedmpkeditor.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/advancedmpkeditor.composeapp.generated.resources/"

@delegate:ResourceContentHash(-446_367_499)
internal val Res.drawable.acacia_boat: DrawableResource by lazy {
      DrawableResource("drawable:acacia_boat", setOf(
        ResourceItem(setOf(), "${MD}drawable/acacia_boat.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_386_084_104)
internal val Res.drawable.acacia_button: DrawableResource by lazy {
      DrawableResource("drawable:acacia_button", setOf(
        ResourceItem(setOf(), "${MD}drawable/acacia_button.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_136_664_981)
internal val Res.drawable.acacia_door: DrawableResource by lazy {
      DrawableResource("drawable:acacia_door", setOf(
        ResourceItem(setOf(), "${MD}drawable/acacia_door.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_458_722_385)
internal val Res.drawable.acacia_fence: DrawableResource by lazy {
      DrawableResource("drawable:acacia_fence", setOf(
        ResourceItem(setOf(), "${MD}drawable/acacia_fence.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-358_339_597)
internal val Res.drawable.acacia_fence_gate: DrawableResource by lazy {
      DrawableResource("drawable:acacia_fence_gate", setOf(
        ResourceItem(setOf(), "${MD}drawable/acacia_fence_gate.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_463_970_525)
internal val Res.drawable.acacia_leaves: DrawableResource by lazy {
      DrawableResource("drawable:acacia_leaves", setOf(
        ResourceItem(setOf(), "${MD}drawable/acacia_leaves.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-778_525_826)
internal val Res.drawable.acacia_log: DrawableResource by lazy {
      DrawableResource("drawable:acacia_log", setOf(
        ResourceItem(setOf(), "${MD}drawable/acacia_log.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(80_837_441)
internal val Res.drawable.acacia_planks: DrawableResource by lazy {
      DrawableResource("drawable:acacia_planks", setOf(
        ResourceItem(setOf(), "${MD}drawable/acacia_planks.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(984_031_837)
internal val Res.drawable.acacia_pressure_plate: DrawableResource by lazy {
      DrawableResource("drawable:acacia_pressure_plate", setOf(
        ResourceItem(setOf(), "${MD}drawable/acacia_pressure_plate.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(160_670_803)
internal val Res.drawable.acacia_sapling: DrawableResource by lazy {
      DrawableResource("drawable:acacia_sapling", setOf(
        ResourceItem(setOf(), "${MD}drawable/acacia_sapling.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-959_637_520)
internal val Res.drawable.acacia_sign: DrawableResource by lazy {
      DrawableResource("drawable:acacia_sign", setOf(
        ResourceItem(setOf(), "${MD}drawable/acacia_sign.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(433_977_556)
internal val Res.drawable.acacia_slab: DrawableResource by lazy {
      DrawableResource("drawable:acacia_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/acacia_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_141_191_628)
internal val Res.drawable.acacia_stairs: DrawableResource by lazy {
      DrawableResource("drawable:acacia_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/acacia_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-108_732_764)
internal val Res.drawable.acacia_trapdoor: DrawableResource by lazy {
      DrawableResource("drawable:acacia_trapdoor", setOf(
        ResourceItem(setOf(), "${MD}drawable/acacia_trapdoor.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_145_371_550)
internal val Res.drawable.acacia_wood: DrawableResource by lazy {
      DrawableResource("drawable:acacia_wood", setOf(
        ResourceItem(setOf(), "${MD}drawable/acacia_wood.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(840_794_195)
internal val Res.drawable.activator_rail: DrawableResource by lazy {
      DrawableResource("drawable:activator_rail", setOf(
        ResourceItem(setOf(), "${MD}drawable/activator_rail.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(134_172_637)
internal val Res.drawable.air: DrawableResource by lazy {
      DrawableResource("drawable:air", setOf(
        ResourceItem(setOf(), "${MD}drawable/air.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-833_216_074)
internal val Res.drawable.allium: DrawableResource by lazy {
      DrawableResource("drawable:allium", setOf(
        ResourceItem(setOf(), "${MD}drawable/allium.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_563_661_697)
internal val Res.drawable.ancient_debris: DrawableResource by lazy {
      DrawableResource("drawable:ancient_debris", setOf(
        ResourceItem(setOf(), "${MD}drawable/ancient_debris.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_039_486_614)
internal val Res.drawable.andesite: DrawableResource by lazy {
      DrawableResource("drawable:andesite", setOf(
        ResourceItem(setOf(), "${MD}drawable/andesite.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(130_811_037)
internal val Res.drawable.andesite_slab: DrawableResource by lazy {
      DrawableResource("drawable:andesite_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/andesite_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-961_146_140)
internal val Res.drawable.andesite_stairs: DrawableResource by lazy {
      DrawableResource("drawable:andesite_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/andesite_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_782_014_649)
internal val Res.drawable.andesite_wall: DrawableResource by lazy {
      DrawableResource("drawable:andesite_wall", setOf(
        ResourceItem(setOf(), "${MD}drawable/andesite_wall.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_126_021_006)
internal val Res.drawable.anvil: DrawableResource by lazy {
      DrawableResource("drawable:anvil", setOf(
        ResourceItem(setOf(), "${MD}drawable/anvil.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_141_393_078)
internal val Res.drawable.apple: DrawableResource by lazy {
      DrawableResource("drawable:apple", setOf(
        ResourceItem(setOf(), "${MD}drawable/apple.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_362_390_464)
internal val Res.drawable.armor_stand: DrawableResource by lazy {
      DrawableResource("drawable:armor_stand", setOf(
        ResourceItem(setOf(), "${MD}drawable/armor_stand.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-361_416_259)
internal val Res.drawable.arrow: DrawableResource by lazy {
      DrawableResource("drawable:arrow", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(61_627_809)
internal val Res.drawable.azure_bluet: DrawableResource by lazy {
      DrawableResource("drawable:azure_bluet", setOf(
        ResourceItem(setOf(), "${MD}drawable/azure_bluet.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_712_255_617)
internal val Res.drawable.baked_potato: DrawableResource by lazy {
      DrawableResource("drawable:baked_potato", setOf(
        ResourceItem(setOf(), "${MD}drawable/baked_potato.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-191_993_233)
internal val Res.drawable.bamboo: DrawableResource by lazy {
      DrawableResource("drawable:bamboo", setOf(
        ResourceItem(setOf(), "${MD}drawable/bamboo.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_976_351_110)
internal val Res.drawable.barrel: DrawableResource by lazy {
      DrawableResource("drawable:barrel", setOf(
        ResourceItem(setOf(), "${MD}drawable/barrel.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(482_283_484)
internal val Res.drawable.barrier: DrawableResource by lazy {
      DrawableResource("drawable:barrier", setOf(
        ResourceItem(setOf(), "${MD}drawable/barrier.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_368_718_135)
internal val Res.drawable.basalt: DrawableResource by lazy {
      DrawableResource("drawable:basalt", setOf(
        ResourceItem(setOf(), "${MD}drawable/basalt.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-827_673_815)
internal val Res.drawable.bat_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:bat_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/bat_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_875_385_115)
internal val Res.drawable.beacon: DrawableResource by lazy {
      DrawableResource("drawable:beacon", setOf(
        ResourceItem(setOf(), "${MD}drawable/beacon.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_134_693_286)
internal val Res.drawable.bedrock: DrawableResource by lazy {
      DrawableResource("drawable:bedrock", setOf(
        ResourceItem(setOf(), "${MD}drawable/bedrock.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_416_186_378)
internal val Res.drawable.bee_nest: DrawableResource by lazy {
      DrawableResource("drawable:bee_nest", setOf(
        ResourceItem(setOf(), "${MD}drawable/bee_nest.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_646_561_396)
internal val Res.drawable.bee_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:bee_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/bee_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-896_149_964)
internal val Res.drawable.beef: DrawableResource by lazy {
      DrawableResource("drawable:beef", setOf(
        ResourceItem(setOf(), "${MD}drawable/beef.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-423_387_118)
internal val Res.drawable.beehive: DrawableResource by lazy {
      DrawableResource("drawable:beehive", setOf(
        ResourceItem(setOf(), "${MD}drawable/beehive.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-460_801_814)
internal val Res.drawable.beetroot: DrawableResource by lazy {
      DrawableResource("drawable:beetroot", setOf(
        ResourceItem(setOf(), "${MD}drawable/beetroot.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_029_052_671)
internal val Res.drawable.beetroot_seeds: DrawableResource by lazy {
      DrawableResource("drawable:beetroot_seeds", setOf(
        ResourceItem(setOf(), "${MD}drawable/beetroot_seeds.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-106_952_652)
internal val Res.drawable.beetroot_soup: DrawableResource by lazy {
      DrawableResource("drawable:beetroot_soup", setOf(
        ResourceItem(setOf(), "${MD}drawable/beetroot_soup.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_944_520_013)
internal val Res.drawable.bell: DrawableResource by lazy {
      DrawableResource("drawable:bell", setOf(
        ResourceItem(setOf(), "${MD}drawable/bell.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_906_725_740)
internal val Res.drawable.birch_boat: DrawableResource by lazy {
      DrawableResource("drawable:birch_boat", setOf(
        ResourceItem(setOf(), "${MD}drawable/birch_boat.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_802_753_413)
internal val Res.drawable.birch_button: DrawableResource by lazy {
      DrawableResource("drawable:birch_button", setOf(
        ResourceItem(setOf(), "${MD}drawable/birch_button.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_063_156_134)
internal val Res.drawable.birch_door: DrawableResource by lazy {
      DrawableResource("drawable:birch_door", setOf(
        ResourceItem(setOf(), "${MD}drawable/birch_door.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(553_620_609)
internal val Res.drawable.birch_fence: DrawableResource by lazy {
      DrawableResource("drawable:birch_fence", setOf(
        ResourceItem(setOf(), "${MD}drawable/birch_fence.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_163_138_222)
internal val Res.drawable.birch_fence_gate: DrawableResource by lazy {
      DrawableResource("drawable:birch_fence_gate", setOf(
        ResourceItem(setOf(), "${MD}drawable/birch_fence_gate.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-296_831_216)
internal val Res.drawable.birch_leaves: DrawableResource by lazy {
      DrawableResource("drawable:birch_leaves", setOf(
        ResourceItem(setOf(), "${MD}drawable/birch_leaves.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(331_001_810)
internal val Res.drawable.birch_log: DrawableResource by lazy {
      DrawableResource("drawable:birch_log", setOf(
        ResourceItem(setOf(), "${MD}drawable/birch_log.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_978_623_871)
internal val Res.drawable.birch_planks: DrawableResource by lazy {
      DrawableResource("drawable:birch_planks", setOf(
        ResourceItem(setOf(), "${MD}drawable/birch_planks.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_391_458_112)
internal val Res.drawable.birch_pressure_plate: DrawableResource by lazy {
      DrawableResource("drawable:birch_pressure_plate", setOf(
        ResourceItem(setOf(), "${MD}drawable/birch_pressure_plate.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_988_507_180)
internal val Res.drawable.birch_sapling: DrawableResource by lazy {
      DrawableResource("drawable:birch_sapling", setOf(
        ResourceItem(setOf(), "${MD}drawable/birch_sapling.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-201_735_428)
internal val Res.drawable.birch_sign: DrawableResource by lazy {
      DrawableResource("drawable:birch_sign", setOf(
        ResourceItem(setOf(), "${MD}drawable/birch_sign.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(493_071_944)
internal val Res.drawable.birch_slab: DrawableResource by lazy {
      DrawableResource("drawable:birch_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/birch_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-169_887_495)
internal val Res.drawable.birch_stairs: DrawableResource by lazy {
      DrawableResource("drawable:birch_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/birch_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(203_059_683)
internal val Res.drawable.birch_trapdoor: DrawableResource by lazy {
      DrawableResource("drawable:birch_trapdoor", setOf(
        ResourceItem(setOf(), "${MD}drawable/birch_trapdoor.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-954_289_844)
internal val Res.drawable.birch_wood: DrawableResource by lazy {
      DrawableResource("drawable:birch_wood", setOf(
        ResourceItem(setOf(), "${MD}drawable/birch_wood.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(497_150_429)
internal val Res.drawable.black_banner: DrawableResource by lazy {
      DrawableResource("drawable:black_banner", setOf(
        ResourceItem(setOf(), "${MD}drawable/black_banner.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-474_511_986)
internal val Res.drawable.black_bed: DrawableResource by lazy {
      DrawableResource("drawable:black_bed", setOf(
        ResourceItem(setOf(), "${MD}drawable/black_bed.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_913_489_661)
internal val Res.drawable.black_carpet: DrawableResource by lazy {
      DrawableResource("drawable:black_carpet", setOf(
        ResourceItem(setOf(), "${MD}drawable/black_carpet.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_619_578_630)
internal val Res.drawable.black_concrete: DrawableResource by lazy {
      DrawableResource("drawable:black_concrete", setOf(
        ResourceItem(setOf(), "${MD}drawable/black_concrete.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_044_094_554)
internal val Res.drawable.black_concrete_powder: DrawableResource by lazy {
      DrawableResource("drawable:black_concrete_powder", setOf(
        ResourceItem(setOf(), "${MD}drawable/black_concrete_powder.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-310_566_070)
internal val Res.drawable.black_dye: DrawableResource by lazy {
      DrawableResource("drawable:black_dye", setOf(
        ResourceItem(setOf(), "${MD}drawable/black_dye.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_423_226_380)
internal val Res.drawable.black_glazed_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:black_glazed_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/black_glazed_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_096_945_008)
internal val Res.drawable.black_shulker_box: DrawableResource by lazy {
      DrawableResource("drawable:black_shulker_box", setOf(
        ResourceItem(setOf(), "${MD}drawable/black_shulker_box.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-285_051_921)
internal val Res.drawable.black_stained_glass: DrawableResource by lazy {
      DrawableResource("drawable:black_stained_glass", setOf(
        ResourceItem(setOf(), "${MD}drawable/black_stained_glass.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-697_595_334)
internal val Res.drawable.black_stained_glass_pane: DrawableResource by lazy {
      DrawableResource("drawable:black_stained_glass_pane", setOf(
        ResourceItem(setOf(), "${MD}drawable/black_stained_glass_pane.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_636_714_204)
internal val Res.drawable.black_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:black_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/black_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-861_986_016)
internal val Res.drawable.black_wool: DrawableResource by lazy {
      DrawableResource("drawable:black_wool", setOf(
        ResourceItem(setOf(), "${MD}drawable/black_wool.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_876_690_339)
internal val Res.drawable.blackstone: DrawableResource by lazy {
      DrawableResource("drawable:blackstone", setOf(
        ResourceItem(setOf(), "${MD}drawable/blackstone.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_221_613_783)
internal val Res.drawable.blackstone_slab: DrawableResource by lazy {
      DrawableResource("drawable:blackstone_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/blackstone_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_131_207_834)
internal val Res.drawable.blackstone_stairs: DrawableResource by lazy {
      DrawableResource("drawable:blackstone_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/blackstone_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_078_713_282)
internal val Res.drawable.blackstone_wall: DrawableResource by lazy {
      DrawableResource("drawable:blackstone_wall", setOf(
        ResourceItem(setOf(), "${MD}drawable/blackstone_wall.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_752_484_740)
internal val Res.drawable.blast_furnace: DrawableResource by lazy {
      DrawableResource("drawable:blast_furnace", setOf(
        ResourceItem(setOf(), "${MD}drawable/blast_furnace.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-408_066_829)
internal val Res.drawable.blaze_powder: DrawableResource by lazy {
      DrawableResource("drawable:blaze_powder", setOf(
        ResourceItem(setOf(), "${MD}drawable/blaze_powder.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_080_980_079)
internal val Res.drawable.blaze_rod: DrawableResource by lazy {
      DrawableResource("drawable:blaze_rod", setOf(
        ResourceItem(setOf(), "${MD}drawable/blaze_rod.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-417_214_862)
internal val Res.drawable.blaze_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:blaze_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/blaze_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(997_858_998)
internal val Res.drawable.blue_banner: DrawableResource by lazy {
      DrawableResource("drawable:blue_banner", setOf(
        ResourceItem(setOf(), "${MD}drawable/blue_banner.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(997_734_459)
internal val Res.drawable.blue_bed: DrawableResource by lazy {
      DrawableResource("drawable:blue_bed", setOf(
        ResourceItem(setOf(), "${MD}drawable/blue_bed.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(37_624_917)
internal val Res.drawable.blue_carpet: DrawableResource by lazy {
      DrawableResource("drawable:blue_carpet", setOf(
        ResourceItem(setOf(), "${MD}drawable/blue_carpet.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_661_240_356)
internal val Res.drawable.blue_concrete: DrawableResource by lazy {
      DrawableResource("drawable:blue_concrete", setOf(
        ResourceItem(setOf(), "${MD}drawable/blue_concrete.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_739_383_023)
internal val Res.drawable.blue_concrete_powder: DrawableResource by lazy {
      DrawableResource("drawable:blue_concrete_powder", setOf(
        ResourceItem(setOf(), "${MD}drawable/blue_concrete_powder.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_764_181_977)
internal val Res.drawable.blue_dye: DrawableResource by lazy {
      DrawableResource("drawable:blue_dye", setOf(
        ResourceItem(setOf(), "${MD}drawable/blue_dye.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_094_897_082)
internal val Res.drawable.blue_glazed_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:blue_glazed_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/blue_glazed_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_949_381_166)
internal val Res.drawable.blue_ice: DrawableResource by lazy {
      DrawableResource("drawable:blue_ice", setOf(
        ResourceItem(setOf(), "${MD}drawable/blue_ice.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_577_947_622)
internal val Res.drawable.blue_orchid: DrawableResource by lazy {
      DrawableResource("drawable:blue_orchid", setOf(
        ResourceItem(setOf(), "${MD}drawable/blue_orchid.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-771_577_331)
internal val Res.drawable.blue_shulker_box: DrawableResource by lazy {
      DrawableResource("drawable:blue_shulker_box", setOf(
        ResourceItem(setOf(), "${MD}drawable/blue_shulker_box.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_075_921_314)
internal val Res.drawable.blue_stained_glass: DrawableResource by lazy {
      DrawableResource("drawable:blue_stained_glass", setOf(
        ResourceItem(setOf(), "${MD}drawable/blue_stained_glass.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_067_360_237)
internal val Res.drawable.blue_stained_glass_pane: DrawableResource by lazy {
      DrawableResource("drawable:blue_stained_glass_pane", setOf(
        ResourceItem(setOf(), "${MD}drawable/blue_stained_glass_pane.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-366_502_549)
internal val Res.drawable.blue_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:blue_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/blue_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-976_508_873)
internal val Res.drawable.blue_wool: DrawableResource by lazy {
      DrawableResource("drawable:blue_wool", setOf(
        ResourceItem(setOf(), "${MD}drawable/blue_wool.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_593_593_022)
internal val Res.drawable.bone: DrawableResource by lazy {
      DrawableResource("drawable:bone", setOf(
        ResourceItem(setOf(), "${MD}drawable/bone.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-904_723_701)
internal val Res.drawable.bone_block: DrawableResource by lazy {
      DrawableResource("drawable:bone_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/bone_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_589_257_504)
internal val Res.drawable.bone_meal: DrawableResource by lazy {
      DrawableResource("drawable:bone_meal", setOf(
        ResourceItem(setOf(), "${MD}drawable/bone_meal.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-100_756_612)
internal val Res.drawable.book: DrawableResource by lazy {
      DrawableResource("drawable:book", setOf(
        ResourceItem(setOf(), "${MD}drawable/book.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(968_009_303)
internal val Res.drawable.bookshelf: DrawableResource by lazy {
      DrawableResource("drawable:bookshelf", setOf(
        ResourceItem(setOf(), "${MD}drawable/bookshelf.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_608_247_463)
internal val Res.drawable.bow: DrawableResource by lazy {
      DrawableResource("drawable:bow", setOf(
        ResourceItem(setOf(), "${MD}drawable/bow.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(326_563_432)
internal val Res.drawable.bowl: DrawableResource by lazy {
      DrawableResource("drawable:bowl", setOf(
        ResourceItem(setOf(), "${MD}drawable/bowl.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("acacia_boat", Res.drawable.acacia_boat)
  map.put("acacia_button", Res.drawable.acacia_button)
  map.put("acacia_door", Res.drawable.acacia_door)
  map.put("acacia_fence", Res.drawable.acacia_fence)
  map.put("acacia_fence_gate", Res.drawable.acacia_fence_gate)
  map.put("acacia_leaves", Res.drawable.acacia_leaves)
  map.put("acacia_log", Res.drawable.acacia_log)
  map.put("acacia_planks", Res.drawable.acacia_planks)
  map.put("acacia_pressure_plate", Res.drawable.acacia_pressure_plate)
  map.put("acacia_sapling", Res.drawable.acacia_sapling)
  map.put("acacia_sign", Res.drawable.acacia_sign)
  map.put("acacia_slab", Res.drawable.acacia_slab)
  map.put("acacia_stairs", Res.drawable.acacia_stairs)
  map.put("acacia_trapdoor", Res.drawable.acacia_trapdoor)
  map.put("acacia_wood", Res.drawable.acacia_wood)
  map.put("activator_rail", Res.drawable.activator_rail)
  map.put("air", Res.drawable.air)
  map.put("allium", Res.drawable.allium)
  map.put("ancient_debris", Res.drawable.ancient_debris)
  map.put("andesite", Res.drawable.andesite)
  map.put("andesite_slab", Res.drawable.andesite_slab)
  map.put("andesite_stairs", Res.drawable.andesite_stairs)
  map.put("andesite_wall", Res.drawable.andesite_wall)
  map.put("anvil", Res.drawable.anvil)
  map.put("apple", Res.drawable.apple)
  map.put("armor_stand", Res.drawable.armor_stand)
  map.put("arrow", Res.drawable.arrow)
  map.put("azure_bluet", Res.drawable.azure_bluet)
  map.put("baked_potato", Res.drawable.baked_potato)
  map.put("bamboo", Res.drawable.bamboo)
  map.put("barrel", Res.drawable.barrel)
  map.put("barrier", Res.drawable.barrier)
  map.put("basalt", Res.drawable.basalt)
  map.put("bat_spawn_egg", Res.drawable.bat_spawn_egg)
  map.put("beacon", Res.drawable.beacon)
  map.put("bedrock", Res.drawable.bedrock)
  map.put("bee_nest", Res.drawable.bee_nest)
  map.put("bee_spawn_egg", Res.drawable.bee_spawn_egg)
  map.put("beef", Res.drawable.beef)
  map.put("beehive", Res.drawable.beehive)
  map.put("beetroot", Res.drawable.beetroot)
  map.put("beetroot_seeds", Res.drawable.beetroot_seeds)
  map.put("beetroot_soup", Res.drawable.beetroot_soup)
  map.put("bell", Res.drawable.bell)
  map.put("birch_boat", Res.drawable.birch_boat)
  map.put("birch_button", Res.drawable.birch_button)
  map.put("birch_door", Res.drawable.birch_door)
  map.put("birch_fence", Res.drawable.birch_fence)
  map.put("birch_fence_gate", Res.drawable.birch_fence_gate)
  map.put("birch_leaves", Res.drawable.birch_leaves)
  map.put("birch_log", Res.drawable.birch_log)
  map.put("birch_planks", Res.drawable.birch_planks)
  map.put("birch_pressure_plate", Res.drawable.birch_pressure_plate)
  map.put("birch_sapling", Res.drawable.birch_sapling)
  map.put("birch_sign", Res.drawable.birch_sign)
  map.put("birch_slab", Res.drawable.birch_slab)
  map.put("birch_stairs", Res.drawable.birch_stairs)
  map.put("birch_trapdoor", Res.drawable.birch_trapdoor)
  map.put("birch_wood", Res.drawable.birch_wood)
  map.put("black_banner", Res.drawable.black_banner)
  map.put("black_bed", Res.drawable.black_bed)
  map.put("black_carpet", Res.drawable.black_carpet)
  map.put("black_concrete", Res.drawable.black_concrete)
  map.put("black_concrete_powder", Res.drawable.black_concrete_powder)
  map.put("black_dye", Res.drawable.black_dye)
  map.put("black_glazed_terracotta", Res.drawable.black_glazed_terracotta)
  map.put("black_shulker_box", Res.drawable.black_shulker_box)
  map.put("black_stained_glass", Res.drawable.black_stained_glass)
  map.put("black_stained_glass_pane", Res.drawable.black_stained_glass_pane)
  map.put("black_terracotta", Res.drawable.black_terracotta)
  map.put("black_wool", Res.drawable.black_wool)
  map.put("blackstone", Res.drawable.blackstone)
  map.put("blackstone_slab", Res.drawable.blackstone_slab)
  map.put("blackstone_stairs", Res.drawable.blackstone_stairs)
  map.put("blackstone_wall", Res.drawable.blackstone_wall)
  map.put("blast_furnace", Res.drawable.blast_furnace)
  map.put("blaze_powder", Res.drawable.blaze_powder)
  map.put("blaze_rod", Res.drawable.blaze_rod)
  map.put("blaze_spawn_egg", Res.drawable.blaze_spawn_egg)
  map.put("blue_banner", Res.drawable.blue_banner)
  map.put("blue_bed", Res.drawable.blue_bed)
  map.put("blue_carpet", Res.drawable.blue_carpet)
  map.put("blue_concrete", Res.drawable.blue_concrete)
  map.put("blue_concrete_powder", Res.drawable.blue_concrete_powder)
  map.put("blue_dye", Res.drawable.blue_dye)
  map.put("blue_glazed_terracotta", Res.drawable.blue_glazed_terracotta)
  map.put("blue_ice", Res.drawable.blue_ice)
  map.put("blue_orchid", Res.drawable.blue_orchid)
  map.put("blue_shulker_box", Res.drawable.blue_shulker_box)
  map.put("blue_stained_glass", Res.drawable.blue_stained_glass)
  map.put("blue_stained_glass_pane", Res.drawable.blue_stained_glass_pane)
  map.put("blue_terracotta", Res.drawable.blue_terracotta)
  map.put("blue_wool", Res.drawable.blue_wool)
  map.put("bone", Res.drawable.bone)
  map.put("bone_block", Res.drawable.bone_block)
  map.put("bone_meal", Res.drawable.bone_meal)
  map.put("book", Res.drawable.book)
  map.put("bookshelf", Res.drawable.bookshelf)
  map.put("bow", Res.drawable.bow)
  map.put("bowl", Res.drawable.bowl)
}
